import React from "react";
import styles from "../../../styles/dashboard.module.css";
import DeviceBox from "../../../components/boxes/device";

export default function ListView({data, notDevice, planRefreshRate}) {
    return (
        <div>
            <div className={`${styles.variable_box_container} mt-3`}>
                {data?.map((value) => (
                    <DeviceBox
                        key={value.id}
                        data={value}
                        notDevice={notDevice}
                        planRefreshRate={planRefreshRate}
                    />
                ))}
            </div>
        </div>

    );
}